import {
  Action,
  ActionType,
  IDeletePatientResponse,
} from "models/patients/deletePatient";
import createReducer from "redux/createReducer";

export interface DeletePatientReducerType {
  loading: boolean;
  error?: string;
  deletePatientResponse?: IDeletePatientResponse;
}

const defaultState: DeletePatientReducerType = {
  loading: false,
  error: undefined,
  deletePatientResponse: undefined,
};

export const deletePatientReducer = createReducer<DeletePatientReducerType>(
  defaultState,
  {
    [ActionType.DELETE_PATIENT](state: DeletePatientReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.DELETE_PATIENT_ERROR](
      state: DeletePatientReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.DELETE_PATIENT_SUCCESS](
      state: DeletePatientReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        deletePatientResponse: action.payload,
      };
    },

    [ActionType.DELETE_PATIENT_RESET](state: DeletePatientReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        deletePatientResponse: undefined,
      };
    },
  }
);
